export default __webpack_public_path__ + "static/media/logo2.9171df2a.png";